import { useCurrentuser } from '@uplift/contexts';
import { UserStatus } from '@uplift/types';

const PLACEHOLDER_FIRST_NAME = 'betterhelp';
const PLACEHOLDER_LAST_NAME = 'member';

export const isPlaceholderFirstName = (name?: string | null) =>
  name?.trim().toLowerCase() === PLACEHOLDER_FIRST_NAME;

export const isPlaceholderLastName = (name?: string | null) =>
  name?.trim().toLowerCase() === PLACEHOLDER_LAST_NAME;

export const useIsMissingLegalName = () => {
  const currentUser = useCurrentuser();
  const isRegular = currentUser.status === UserStatus.regular;
  const isNameMissing = !currentUser.firstName?.trim()
    || !currentUser.lastName?.trim()
    || isPlaceholderFirstName(currentUser.firstName)
    || isPlaceholderLastName(currentUser.lastName);

  return isRegular && isNameMissing;
};
